import { useState, useEffect, useRef } from "react";

//Image
import searchIcon from "../../image/search.svg";
import cancelIcon from "../../image/cancel.svg";

//Styles
import { Wrapper, Content } from "./SearchBar.styles";

const SearchBar = ({ setSearchTerm }) => {
    const [state, setState] = useState("");
    const initial = useRef(true);

    useEffect(() => {
        if (initial.current) {
            initial.current = false;
            return;
        }
        const timer = setTimeout(() => {
            setSearchTerm(state);
        }, 1000);

        return () => clearTimeout(timer);
    }, [setSearchTerm, state]);

    return (
        <Wrapper>
            <Content>
                <img src={searchIcon} alt="search-icon" />
                <input
                    type="text"
                    placeholder="Search Movie"
                    onChange={e => {
                        let formattedText = e.currentTarget.value.replace(
                            /^ +/g,
                            ""
                        );
                        formattedText = formattedText.replace(/\s\s+/g, " ");
                        setState(formattedText);
                    }}
                    value={state}
                />
                <img
                    src={cancelIcon}
                    alt="search-icon"
                    onClick={() => setState("")}
                />
            </Content>
        </Wrapper>
    );
};

export default SearchBar;
